import React from 'react';
import './Loader.css';

export type LoaderPropTypes = {
  isLoading: boolean;
  text?: string;
}

export const PureLoader: React.FC<LoaderPropTypes> = (props: LoaderPropTypes) => {
  const { isLoading, text } = props;
  if (!isLoading) {
    return <></>;
  }
  return (
    <div className="loader tc">
      <div className="absolute--fill fixed flex items-center justify-center">
        <div style={{ paddingTop: '10rem' }} className="b">
          {text}
        </div>
      </div>
    </div>
  );
};

export default PureLoader;
